import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0908]">
      {/* Header */}
      <div className="max-w-[800px] mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <a
            href="/"
            className="inline-flex items-center gap-2 text-[#a6a196] hover:text-[#d4af37] transition-colors text-sm mb-8"
          >
            <ArrowLeft className="w-4 h-4" /> Kembali ke Beranda
          </a>

          <div className="flex items-center gap-3 mb-4">
            <div className="w-1 h-8 bg-[#d4af37] rounded-full" />
            <h1 className="font-display text-3xl sm:text-4xl text-[#fdfbf7] tracking-wide">
              Kebijakan Privasi
            </h1>
          </div>
          <p className="text-sm text-[#a6a196] mb-12">
            Terakhir diperbarui: Juni 2026
          </p>
        </motion.div>

        {/* Content sections */}
        <div className="space-y-10 text-[#a6a196] leading-relaxed">
          <Section title="1. Informasi yang Kami Kumpulkan">
            <p>
              Kami mengumpulkan informasi yang Anda berikan secara langsung saat menggunakan layanan kami, termasuk:
            </p>
            <ul className="list-disc pl-5 space-y-1.5 mt-3">
              <li>Nama lengkap dan nomor telepon</li>
              <li>Alamat email</li>
              <li>Tanggal dan detail acara (pernikahan, wisuda, dll)</li>
              <li>Foto-foto yang diambil selama sesi makeup dan acara</li>
              <li>Informasi tentang jenis kulit dan preferensi riasan</li>
            </ul>
          </Section>

          <Section title="2. Penggunaan Informasi">
            <p>Informasi yang kami kumpulkan digunakan untuk:</p>
            <ul className="list-disc pl-5 space-y-1.5 mt-3">
              <li>Memproses reservasi dan konsultasi</li>
              <li>Menyesuaikan layanan makeup dengan kebutuhan Anda</li>
              <li>Mengirimkan konfirmasi jadwal dan pengingat</li>
              <li>Menampilkan portfolio karya kami (dengan izin Anda)</li>
              <li>Meningkatkan kualitas layanan</li>
            </ul>
          </Section>

          <Section title="3. Penyimpanan dan Keamanan Data">
            <p>
              Data Anda disimpan secara aman di platform Firebase (Google Cloud). 
              Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi 
              informasi pribadi Anda dari akses tidak sah, perubahan, atau penghapusan.
            </p>
          </Section>

          <Section title="4. Penggunaan Foto">
            <p>
              Foto-foto yang diambil selama sesi makeup merupakan hak cipta Sanggar Rias Adibah 
              dan dapat digunakan untuk keperluan portfolio, media sosial, dan promosi. 
              Jika Anda tidak ingin foto Anda ditampilkan, silakan sampaikan kepada kami 
              sebelum atau sesudah acara.
            </p>
          </Section>

          <Section title="5. Hak Anda">
            <p>Anda memiliki hak untuk:</p>
            <ul className="list-disc pl-5 space-y-1.5 mt-3">
              <li>Mengakses data pribadi yang kami simpan</li>
              <li>Meminta koreksi atau pembaruan data</li>
              <li>Meminta penghapusan data (kecuali data yang wajib disimpan secara hukum)</li>
              <li>Menolak penggunaan foto Anda untuk keperluan promosi</li>
            </ul>
          </Section>

          <Section title="6. Kontak">
            <p>
              Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, 
              silakan hubungi kami melalui:
            </p>
            <div className="mt-3 space-y-1">
              <p>Email: lw5051900@gmail.com</p>
              <p>WhatsApp: +62 812 8032 7569</p>
            </div>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="font-serif text-xl sm:text-2xl text-[#fdfbf7] mb-4 font-light">
        {title}
      </h2>
      <div className="text-sm leading-relaxed space-y-2">
        {children}
      </div>
    </motion.div>
  );
}
